"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.Wrapper = exports.StyledLabel = exports.OptionsWrapper = exports.ListWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const StyledLabel = exports.StyledLabel = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e141unqb3"
} : {
  target: "e141unqb3",
  label: "StyledLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "1ge8ozm",
  styles: "line-height:22px;font-size:1em;font-weight:600;margin-bottom:4px"
} : {
  name: "1ge8ozm",
  styles: "line-height:22px;font-size:1em;font-weight:600;margin-bottom:4px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e141unqb2"
} : {
  target: "e141unqb2",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "fnf23l",
  styles: "position:relative;ul{border-top:none;}"
} : {
  name: "fnf23l",
  styles: "position:relative;ul{border-top:none;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const OptionsWrapper = exports.OptionsWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e141unqb1"
} : {
  target: "e141unqb1",
  label: "OptionsWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "zje6v4",
  styles: "position:absolute;left:0;right:0;min-width:150px;box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.1);z-index:1000;border-radius:10px;overflow:hidden;background:#fff;width:max-content;@media (max-width: 768px){width:auto;}"
} : {
  name: "zje6v4",
  styles: "position:absolute;left:0;right:0;min-width:150px;box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.1);z-index:1000;border-radius:10px;overflow:hidden;background:#fff;width:max-content;@media (max-width: 768px){width:auto;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ListWrapper = exports.ListWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e141unqb0"
} : {
  target: "e141unqb0",
  label: "ListWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1xlkuzg",
  styles: "max-height:10em;overflow-x:hidden;overflow-y:auto"
} : {
  name: "1xlkuzg",
  styles: "max-height:10em;overflow-x:hidden;overflow-y:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const styles = exports.styles = {
  opacity08: process.env.NODE_ENV === "production" ? {
    name: "eoqxuw",
    styles: "display:flex;justify-content:space-between;align-items:center;padding:0 0.5em;height:39px;background-color:rgba(216, 216, 216, 0.08);border:1px solid rgba(255, 255, 255, 0.24);border-radius:5px;color:white;&>button>span{color:white;font-weight:400;}button svg polygon{fill:white;}button{width:100%;}button+div{top:40px;}"
  } : {
    name: "6fnvbj-opacity08",
    styles: "display:flex;justify-content:space-between;align-items:center;padding:0 0.5em;height:39px;background-color:rgba(216, 216, 216, 0.08);border:1px solid rgba(255, 255, 255, 0.24);border-radius:5px;color:white;&>button>span{color:white;font-weight:400;}button svg polygon{fill:white;}button{width:100%;}button+div{top:40px;};label:opacity08;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};